<template>
  <div style="padding-top:100px;">
    <!-- start hero -->
    <div id="hero" class="jarallax" data-speed="0.7" data-img-position="50% 55%" style="background-image: url(img/contact_img.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-7">
            <h1 class="__title">contáctanos</h1>

            <p>
              Estamos para atender cualquier duda que tengas
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- end hero -->

    <main role="main">
      <link rel="stylesheet" href="css/style.min.css" type="text/css">

      <!-- start section -->
      <section class="section">
        <div class="container">
          <!-- start company contacts -->
          <div class="company-contacts  text-center">
            <div class="__inner">
              <div class="row justify-content-around">
                <!-- start item -->
                <div class="col-12 col-md-4 col-lg-3">
                  <div class="__item">
                    <i class="__ico fontello-location"></i>

                    <h4 class="__title">Dirección</h4>

                    <p>Calle Industrial 4, lote 44B, La Primavera, C.P. 80300 Culiacán Sin. México Tel. +52 (667) 760-37-50 y 40 ventas@agrobiosol.com.mx</p>
                  </div>
                </div>
                <!-- end item -->

                <!-- start item -->
                <div class="col-12 col-md-4 col-lg-3">
                  <div class="__item">
                    <i class="__ico fontello-phone"></i>

                    <h4 class="__title">Teléfonos</h4>

                    <p>
                      T +52 (667) 760 37 50<br>F +52 (667) 760 37 40
                    </p>
                  </div>
                </div>
                <!-- end item -->

                <!-- start item -->
                <div class="col-12 col-md-4 col-lg-3">
                  <div class="__item">
                    <i class="__ico fontello-mail-1"></i>

                    <h4 class="__title">Correo Electrónico</h4>

                    <p>
                      <a href="mailto:ventas@agrobiosol.com.mx">ventas@agrobiosol.com.mx</a><br>
                      <a href="mailto:auxventas@agrobiosol.com.mx">auxventas@agrobiosol.com.mx</a>
                    </p>
                  </div>
                </div>
                <!-- end item -->
              </div>
            </div>
          </div>
          <!-- end company contacts -->
        </div>
      </section>
      <!-- end section -->  
      
      <Contact /> 
    </main>
  </div>	
</template>

<script>
import Map from '@/components/Map.vue'
import Contact from '@/components/Contact.vue'
import Modal from '@/components/Modal.vue'
import axios from 'axios'

export default {
  components: {
    Map,
    Contact,
    Modal
  }
};
</script>

<style>
</style>